import { POPUP_CONTENT_ID } from 'client/constants/editorIds'
import { PopupInterface } from 'common/types/entities/popup-interface'
import React from 'react'
import { PopupClose } from './ui/popup-close'
import { PopupContentUi } from './ui/popup-content-ui'
import { PopupDialogUi } from './ui/popup-dialog-ui'
import { PopupScrollContentUi } from './ui/popup-scroll-content-ui'

interface CommonPopupProps {
  entity: PopupInterface
  children: React.ReactNode
  onCloseHandler?: () => void
  showClose?: boolean
  maxHeight: string
  backgroundColor?: string
  mobileBackgroundColor?: string
}

export const CommonPopup = ({
  entity,
  showClose = false,
  onCloseHandler,
  children,
  maxHeight,
  backgroundColor,
  mobileBackgroundColor,
}: CommonPopupProps) => {
  return (
    <PopupDialogUi
      id={entity.htmlAttrId}
      background={entity.background || backgroundColor}
      mobileBackground={entity.mobileBackground || mobileBackgroundColor}
      width={entity.width || 600}
      border={entity.border}
      mobileBorder={entity.mobileBorder}
      boxShadow={entity.boxShadow}
      mobileBoxShadow={entity.mobileBoxShadow}
      maxHeight={maxHeight}
    >
      <PopupScrollContentUi
        id={POPUP_CONTENT_ID}
        padding={entity.padding}
        mobilePadding={entity.mobilePadding}
      >
        {Boolean(Number(showClose)) && (
          <PopupClose
            color={entity.closeButtonColor}
            mobileColor={entity.closeButtonMobileColor}
            onClose={onCloseHandler}
          />
        )}
        <PopupContentUi>{children}</PopupContentUi>
      </PopupScrollContentUi>
    </PopupDialogUi>
  )
}
